import global from "@/plugin/global"

export default [
    {
        name: "root",
        path: "/",
        component: () => import(/* webpackChunkName: "main" */ "@/view/apps/Main.vue"),
        meta: {
            layout: "DefaultLayout",
            title: "Dot Apps : Home",
            auth: false,
        },
    },
    {
        name: "canvas",
        path: "/canvas",
        component: () => import(/* webpackChunkName: "dot-canvas" */ /* webpackPrefetch: true */ "@/view/apps/DotCanvas.vue"),
        meta: {
            layout: "WideLayout",
            title: "Dot Apps : Dot Canvas",
        },
    },
    {
        name: "book",
        path: "/book",
        component: () => import(/* webpackChunkName: "dot-book" */ "@/view/apps/DotBook.vue"),
        meta: {
            layout: "WideLayout",
            title: "Dot Apps : Dot Book",
        },
    },
    {
        name: "cloud",
        path: "/cloud",
        component: () => import(/* webpackChunkName: "dot-cloud" */ "@/view/apps/DotCloud.vue"),
        meta: {
            layout: "CloudLayout",
            title: "Dot Apps : Dot Cloud",
        },
    },
]